$(document).ready(function() {
  $('.notify_failure').hide();
  $('.notify_success').hide();
  
  function validateEmail(email) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
      }
  $('#MailNotify').click(function(event) {
    // Prevent default form submission
   event.preventDefault();
   var textColor = $(".form__label__value").text();
   $("#p-color").attr('value',textColor);

    // Select the hidden input and the span element
    var hiddenInput = document.getElementById("p-color");
    var spanElement = document.querySelector(".form__label__value");
    
    // Assign the inner text of the span to the value of the hidden input
    if (hiddenInput && spanElement) {
        hiddenInput.value = spanElement.innerText;
    }
    
    // Get the email value
    var email = $('#emails').val();

    // Get the product name value
    var productName = $('#p-name').val();
    var productUrl = $('#p-url').val();
    var productId = $('#p-id').val();
    var productPrice = $("#product-price").val();
    var productImage = $("#product-image").val();
    var productColor = hiddenInput.value;
    var variantSku = $("#variant-sku").val();
    var variantId = $("#variant-id").val();
    var storeLanguage = $("#store-language").val();
    var customerId = $("#customerid").val();
    var customerName = $("#customername").val();


    console.log('Email to be posted:-', email);
    console.log('Product Name:-', productName);
    console.log('Product Url:-', productUrl);
    console.log('product Id:-', productId);
    console.log('product Price:-', productPrice);
    console.log('product Image:-', productImage);
    console.log('Product Color:-', productColor);
    console.log('Variant Sku:-', variantSku);
    console.log('variant Id:-', variantId);
    console.log('storeLanguage:-', storeLanguage);
    console.log('customer Id:-', customerId);
    console.log('customer Name:-', customerName);

    
    // Validate the email if necessary
    // Perform any other actions with the email value, such as posting it to a server

      if (!validateEmail(email)) {
        alert("Please enter a valid email address.");
        return false;
      }
    
    // Example: post the email using AJAX
    $.ajax({
      url: 'https://vmhexagona.772424.hosting/shopify_apps/hexagona-export-import/import-script/email_alert.php',
      type: 'POST',
      data: { email: email, productName: productName, productUrl: productUrl, productId: productId, productPrice: productPrice, productImage: productImage, productColor: productColor, 
               variantSku: variantSku, variantId: variantId, storeLanguage: storeLanguage, customerId: customerId, customerName: customerName }, // Removed the trailing comma
      success: function(response){
        if (response === "Customer data registered") {
          $('.notify_success').show();
          $('.notify_failure').hide();
        } else if (response === "Already registered this mail") {
          $('.notify_failure').show();
          $('.notify_success').hide();
        } else {
          console.error('Unexpected response:', response);
        }
      },
      
      error: function(xhr, status, error) {
        console.error('Error posting email:', error);
        $('.notify_failure').show();
        $('.notify_success').hide();
      }
    });
  });
});